import Badge, { Color } from "../../../atoms/Badge";

/**
 * 상품분류 enum
 */
export enum DeliveryStatus {
  DELIVERY = "정상",
  RETURN = "반품",
}

/**
 * 상품분류 key type
 */
export type DeliveryStatusType = keyof typeof DeliveryStatus;

/**
 * 상품분류별 색상
 */
export const deliveryStatusTypeColor: {
  [key: string]: Color;
} = {
  DELIVERY: "blue",
  RETURN: "red",
};

interface DeliveryStatusTagProps {
  value: DeliveryStatusType;
}

/**
 * 상품분류 태그
 * @param value
 * @returns
 */
export const DeliveryStatusTag: React.FC<DeliveryStatusTagProps> = ({
  value,
}) => {
  return (
    <>
      {DeliveryStatus[value] ? (
        <Badge color={deliveryStatusTypeColor[value] as Color}>
          {DeliveryStatus[value]}
        </Badge>
      ) : (
        "-"
      )}
    </>
  );
};
